import { ValidationErrorResponseSchema } from '@mntn/api-contracts/_shared/error-responses'
import { ErrorResponseSchema } from '@mntn/result'
import { initContract } from '@ts-rest/core'
import { GetProgramRatingsRequestSchema, GetProgramRatingsResponseSchema } from './schemas.ts'

const c = initContract()

export const programRatingsContract = c.router(
  {
    list: c.query({
      method: 'GET',
      path: '/seller/v1/program-ratings',
      description: 'Get program ratings',
      request: GetProgramRatingsRequestSchema,
      responses: GetProgramRatingsResponseSchema,
    }),
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      400: ValidationErrorResponseSchema,
      403: ErrorResponseSchema,
    },
    metadata: { tags: ['Program Ratings'] },
  },
)

export type ProgramRatingsContract = typeof programRatingsContract
